import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { getAllFoodItems, updateFoodItem } from '../actions/index'
import { connect } from 'react-redux'
import '../App.css';



class UpdateFoodItem extends React.Component {
    constructor(props){
        super(props)
        this.state= {
            name:'',
            time:'',
            description: '',
            pickup_date: '',
            deleteId: '',
            updateId: '',
            claimId: '',
        }
    }

    componentDidMount(){
        this.props.getAllFoodItems()                
        console.log(this.allFoodItems)
       
    }

    handleChange = (evt) => {
        evt.preventDefault()
        this.setState({
            [evt.target.name]: evt.target.value,
        })
    }

    handleChange2 = (evt) => {
        evt.preventDefault()
        this.setState({
            deleteId: evt.target.value,
        })
    }

    handleChange3 = (evt) => {
        evt.preventDefault()
        this.setState({
            updateId: evt.target.value,
        })
    }

    handleChange4 = (evt) => {
        evt.preventDefault()
        this.setState({
            claimId: evt.target.value,
        })
    }

    // updateItem = (evt) => {
    //     evt.preventDefault()
    //     const id = this.props.match.params.id
    //     const { name, time, description, is_claimed, pickup_date } = this.state
    //     const payload = {name, time, description, is_claimed, pickup_date}
    //     axios.put(`${id}`, payload)
    //     this.setState({name:'', time:'', description: '', is_claimed: '', pickup_date: '',})
    // }

    updateItem = (evt) => {
		evt.preventDefault()
        const headers = {Authorization: localStorage.getItem('token')}
		const id = this.state.updateId
		const { name, time, description, is_claimed, pickup_date } = this.state
		const payload = { name, time, description, is_claimed, pickup_date }
		
		axios.put(`https://bw-replate.herokuapp.com/api/food/${id}`, payload, { headers })
			.then((response) => {
                console.log(response)
                alert("Item Updated")
			})
			.catch((err) => {
				this.setState({
					errorMessage: err.response.data.error
				})
			})
    }
    
    claimItem = (evt) => {
		evt.preventDefault()
        const headers = {Authorization: localStorage.getItem('token')}
		const id = this.state.claimId
		const payload = { is_claimed: 1 }
		
		axios.put(`https://bw-replate.herokuapp.com/api/food/${id}`, payload, { headers })
			.then((response) => {
                console.log(response)
				alert("Item Claimed")
			})
			.catch((err) => {
				this.setState({
					errorMessage: err.response.data.error
				})
			})
	}

	deleteItem = (evt) => {
		evt.preventDefault()

		const id = this.state.deleteId
        const headers = {Authorization: localStorage.getItem('token')}
		axios.delete(`https://bw-replate.herokuapp.com/api/food/${id}`, { headers })
			.then((response) => {
				
                console.log(response)
                alert("Item Deleted")
			})
			.catch((err) => {
				this.setState({
					errorMessage: err.response.data.error
				})
			})
	}

    render() {
        console.log(this.props)
        const { name, time, description, pickup_date, deleteId, updateId, claimId } = this.state
        return (
            <div>
                <Link className="abutton" to='/volunteerdashboard'>Volunteer Dashboard</Link>
                <br /><br />
                <form onSubmit={this.updateItem}>
                    <input type="text" name="id" value={updateId} placeholder="Id of Food Item" onChange={this.handleChange3} required /><br />
                    <input type="text" name="name" value={name} placeholder="Food item name" onChange={this.handleChange} required /><br/>
                    <input type="text" name="time" value={time} placeholder="Request a Pickup Time" onChange={this.handleChange} required /><br/>
                    <input type="text" name="description" value={description} placeholder="Food item description" onChange={this.handleChange} required /><br/>
                    <input type="text" name="pickup_date" value={pickup_date} placeholder="Request a Pickup Date" onChange={this.handleChange} required /><br/>
                    <button type="submit" className="abutton" >Update Food Item for Pickup</button>
                </form>
                <br />
                <form onSubmit={this.deleteItem}>
                    <input type="text" name="id" value={deleteId} placeholder="Id of Food Item" onChange={this.handleChange2} required /><br />
                    <button type="submit" className="abutton" >Delete Item</button>
                </form>
                <br />
                <form onSubmit={this.claimItem}>
                    <input type="text" name="id" value={claimId} placeholder="Id of Food Item" onChange={this.handleChange4} required /><br />
                    <button className="abutton" type="submit">Claim Item</button>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    allFoodItems: state.allFoodItems
})

const mapDispatchToProps = {
    getAllFoodItems, 
    updateFoodItem,
}


export default connect(mapStateToProps, mapDispatchToProps)(UpdateFoodItem)